import request from '@/utils/request'
import qs from 'qs'
//用户/管理员登录
export function login(username, password) {
  return request({
    url: '/login',
    method: 'post',
    data: qs.stringify({
      username,
      password
    })
  })
}

export function getInfo() {
  return request({
    url: '/info',
    method: 'get',
  })
}
//获取我的个人信息
export function getMyInfo() {
  return request({
    url: '/getMyInfo',
    method: 'get',
  })
}
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js